import { Flex, Switch } from "antd"
import React, { useCallback } from "react"

import type { ColumnKey, OnBulkChange, SectionRecord } from "../types.ts"
import type { PermissionFeatures } from "../types/permissions.types.ts"

interface PermissionsColumnToggleSwitchProps {
  parentKey: keyof PermissionFeatures
  colKey: ColumnKey
  allChecked: boolean
  hasCol: boolean
  restSubKeys: SectionRecord
  onBulkChange: OnBulkChange
  isUpdating?: boolean
  disabled?: boolean
}

export const PermissionsColumnToggleSwitch = ({
  parentKey,
  colKey,
  allChecked,
  hasCol,
  restSubKeys,
  onBulkChange,
  isUpdating,
  disabled
}: PermissionsColumnToggleSwitchProps) => {
  const handleChange = useCallback(
    (v: boolean) => onBulkChange(parentKey, colKey, restSubKeys, v),
    [parentKey, colKey, restSubKeys, onBulkChange]
  )

  return (
    <Flex justify="center">
      {hasCol ? (
        <Flex
          justify={"center"}
          align={"center"}
          className="px-2 py-1 rounded border border-border shadow-sm"
        >
          <Switch
            size="small"
            checked={allChecked}
            onChange={handleChange}
            disabled={isUpdating || disabled}
          />
        </Flex>
      ) : (
        <span />
      )}
    </Flex>
  )
}
